/* Granite City Graphics redesign: small behaviours for gcg-* sections */
(function () {
  function initHero(root) {
    root.querySelectorAll('.gcg-hero').forEach(function (hero) {
      if (hero.dataset.gcgInit) return;
      hero.dataset.gcgInit = '1';
      requestAnimationFrame(function () { hero.classList.add('is-ready'); });
    });
  }

  function initServices(root) {
    root.querySelectorAll('[data-gcg-services]').forEach(function (wrap) {
      if (wrap.dataset.gcgInit) return;
      wrap.dataset.gcgInit = '1';
      var items = wrap.querySelectorAll('.gcg-svc');
      var imgs = wrap.querySelectorAll('.gcg-services__stage img');
      function activate(i) {
        items.forEach(function (el, n) { el.classList.toggle('is-active', n === i); });
        imgs.forEach(function (el) { el.classList.toggle('is-active', Number(el.dataset.index) === i); });
      }
      items.forEach(function (el, i) {
        el.addEventListener('mouseenter', function () { activate(i); });
        el.addEventListener('focusin', function () { activate(i); });
      });
      if (items.length) activate(0);
    });
  }

  function initShade(root) {
    root.querySelectorAll('[data-gcg-shade]').forEach(function (wrap) {
      if (wrap.dataset.gcgInit) return;
      wrap.dataset.gcgInit = '1';
      var film = wrap.querySelector('.gcg-shade__film');
      var label = wrap.querySelector('.gcg-shade__label');
      wrap.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.addEventListener('change', function () {
          film.style.setProperty('--film', input.dataset.film);
          label.textContent = input.dataset.label;
        });
      });
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-gcg-tabs]').forEach(function (wrap) {
      if (wrap.dataset.gcgInit) return;
      wrap.dataset.gcgInit = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var next = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            select(tabs[next], true);
          }
        });
      });
    });
  }

  function init(root) {
    root = root || document;
    initHero(root); initServices(root); initShade(root); initTabs(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
